export default __webpack_public_path__ + "static/media/scraping-can.084f514b.mp3";